(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-order-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const form = section.querySelector('form');
    if (!form) return;
    const success = section.querySelector('[data-success]');
    if (success) { success.focus({ preventScroll: true }); return; }
    const steps = [...section.querySelectorAll('[data-form-step]')];
    const progress = [...section.querySelectorAll('[data-progress-step]')];
    const items = section.querySelector('[data-items]');
    const template = section.querySelector('[data-item-template]');
    const summary = section.querySelector('[data-summary]');
    const body = section.querySelector('[data-quote-body]');
    const rows = () => [...items.querySelectorAll('[data-item]')];
    let current = 0;
    const updateRow = row => {
      row.querySelectorAll('[data-size]').forEach(select => {
        const wrap = row.querySelector('[data-custom="' + select.dataset.size + '"]');
        const input = wrap.querySelector('input');
        const active = select.value === 'custom';
        wrap.hidden = !active;
        input.disabled = !active;
        input.required = active;
      });
      const colorGroup = row.querySelector('[data-colors]');
      const colored = row.querySelector('[data-key="Type"]:checked')?.value === 'colored';
      colorGroup.hidden = !colored;
      colorGroup.disabled = !colored;
      const custom = colored && row.querySelector('[data-key="Color"]:checked')?.value === 'custom';
      const wrap = row.querySelector('[data-color-custom]');
      wrap.hidden = !custom;
      wrap.querySelector('input').disabled = !custom;
      wrap.querySelector('input').required = custom;
    };
    const renumber = () => rows().forEach((row, index) => {
      row.querySelector('[data-item-number]').textContent = index + 1;
      const idMap = new Map();
      row.querySelectorAll('[id]').forEach((el, i) => {
        const id = form.id + '-row-' + (index + 1) + '-control-' + i;
        idMap.set(el.id, id);
        el.id = id;
      });
      row.querySelectorAll('[for]').forEach(el => el.htmlFor = idMap.get(el.htmlFor) || el.htmlFor);
      row.querySelectorAll('[aria-describedby]').forEach(el => {
        el.setAttribute('aria-describedby', el.getAttribute('aria-describedby').split(' ').map(id => idMap.get(id) || id).join(' '));
      });
      row.querySelectorAll('[data-key]').forEach(el => el.name = 'contact[Product ' + (index + 1) + ' - ' + el.dataset.key + ']');
      row.querySelector('[data-remove]').hidden = rows().length === 1;
      updateRow(row);
    });
    const describe = (row, index) => {
      const type = row.querySelector('[data-key="Type"]:checked');
      const title = (index + 1) + '. ' + (type ? type.closest('label').textContent.trim() : section.dataset.empty);
      const parts = [];
      const quantity = row.querySelector('[data-key="Quantity"]').value;
      if (quantity) parts.push(quantity + ' ' + section.dataset.rolls);
      row.querySelectorAll('[data-size]').forEach(select => {
        if (!select.value) return;
        const label = select.labels[0].textContent.trim();
        const input = row.querySelector('[data-custom="' + select.dataset.size + '"] input');
        const unit = select.dataset.size === 'length' ? ' m' : ' mm';
        const value = select.value === 'custom' ? input.value + unit : select.selectedOptions[0].textContent.trim();
        parts.push(label + ': ' + value);
      });
      const colors = row.querySelector('[data-colors]');
      const color = row.querySelector('[data-key="Color"]:checked');
      if (!colors.disabled && color?.value) {
        const value = color.value === 'custom' ? row.querySelector('[data-key="Custom color"]').value : color.closest('label').textContent.trim();
        parts.push(colors.querySelector('legend').textContent.trim() + ': ' + value);
      }
      const notes = row.querySelector('[data-key="Notes"]').value.trim();
      if (notes) parts.push(notes);
      return { title, details: parts.length ? parts.join('\n') : section.dataset.empty };
    };
    const updateSummary = () => {
      const descriptions = rows().map(describe);
      summary.replaceChildren();
      descriptions.forEach(item => {
        const card = document.createElement('div');
        card.className = 'bulk-order__summary-item';
        const title = document.createElement('h4');
        title.textContent = item.title;
        const details = document.createElement('p');
        details.textContent = item.details;
        card.append(title, details);
        summary.append(card);
      });
      body.value = descriptions.map(item => item.title + '\n' + item.details).join('\n\n');
    };
    const show = (index, focus = false) => {
      current = index;
      if (index === steps.length - 1) updateSummary();
      steps.forEach((step, i) => step.hidden = i !== index);
      progress.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        item.classList.toggle('is-complete', i < index);
        if (i === index) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      if (focus) {
        steps[index].querySelector('legend').focus({ preventScroll: true });
        section.querySelector('.bulk-order__form-card').scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    };
    const validate = index => {
      const invalid = [...steps[index].querySelectorAll('input,select,textarea')].find(el => el.willValidate && !el.checkValidity());
      if (!invalid) return true;
      show(index);
      invalid.reportValidity();
      return false;
    };
    const add = source => {
      const row = template.content.querySelector('[data-item]').cloneNode(true);
      if (source) {
        const original = [...source.querySelectorAll('input,select,textarea')];
        row.querySelectorAll('input,select,textarea').forEach((input, i) => {
          input.value = original[i].value;
          if (input.type === 'radio') input.checked = original[i].checked;
        });
      }
      const nextIndex = rows().length + 1;
      row.querySelectorAll('[data-key]').forEach(el => el.name = 'contact[Product ' + nextIndex + ' - ' + el.dataset.key + ']');
      items.append(row);
      renumber();
      row.querySelector('h3').focus();
      section.querySelector('[data-item-status]').textContent = section.dataset.added;
    };
    section.querySelector('[data-add]').addEventListener('click', () => add());
    items.addEventListener('click', event => {
      const duplicate = event.target.closest('[data-duplicate]');
      const remove = event.target.closest('[data-remove]');
      if (duplicate) add(duplicate.closest('[data-item]'));
      if (remove && rows().length > 1) {
        const index = rows().indexOf(remove.closest('[data-item]'));
        remove.closest('[data-item]').remove();
        renumber();
        rows()[Math.min(index, rows().length - 1)].querySelector('h3').focus();
        section.querySelector('[data-item-status]').textContent = section.dataset.removed;
      }
    });
    items.addEventListener('change', event => updateRow(event.target.closest('[data-item]')));
    const frequencyField = section.querySelector('[data-frequency-field]');
    const frequency = section.querySelector('[data-frequency-select]');
    const updateFrequency = () => {
      const recurring = section.querySelector('[data-order-type="recurring"]').checked;
      frequencyField.hidden = !recurring;
      frequency.disabled = !recurring;
      frequency.required = recurring;
    };
    section.querySelectorAll('[data-order-type]').forEach(el => el.addEventListener('change', updateFrequency));
    steps.forEach(step => step.querySelector('legend').setAttribute('tabindex', '-1'));
    section.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => {
      if (validate(current)) show(current + 1, true);
    }));
    section.querySelectorAll('[data-previous]').forEach(button => button.addEventListener('click', () => show(current - 1, true)));
    section.querySelector('[data-edit]').addEventListener('click', () => show(0, true));
    form.addEventListener('submit', event => {
      if (current < steps.length - 1) {
        event.preventDefault();
        if (validate(current)) show(current + 1, true);
        return;
      }
      for (let i = 0; i < steps.length; i++) {
        if (!validate(i)) { event.preventDefault(); return; }
      }
      updateSummary();
    });
    renumber();
    updateFrequency();
    section.querySelector('[data-review]').hidden = false;
    body.disabled = false;
    form.noValidate = true;
    show(0);
    section.classList.add('bulk-order--enhanced');
  };
  document.querySelectorAll('[data-bulk-order]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bulk-order]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorted-editorial-article"]) return;
  try {
    
if (!customElements.get('sorted-editorial')) {
  customElements.define('sorted-editorial', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const progress = this.querySelector('.se-progress');
      const body = this.querySelector('.se-body');
      const update = () => {
        const rect = body.getBoundingClientRect();
        const total = Math.max(1, rect.height - window.innerHeight + 130);
        progress.style.transform = `scaleX(${Math.max(0, Math.min(1, (130 - rect.top) / total))})`;
        const headings = [...body.querySelectorAll('h2[id]')];
        const active = headings.filter(h => h.getBoundingClientRect().top < 190).at(-1) || headings[0];
        this.querySelectorAll('.se-toc a').forEach(a => {
          if (active && a.hash === '#' + active.id) a.setAttribute('aria-current', 'location');
          else a.removeAttribute('aria-current');
        });
      };
      let queued = false;
      window.addEventListener('scroll', () => { if (!queued) {queued = true;requestAnimationFrame(() => {update();queued = false;});}}, { passive: true, signal });
      window.addEventListener('resize', update, { signal });
      update();
      this.querySelector('[data-copy-link]').addEventListener('click', async event => {
        const button = event.currentTarget;
        try { await navigator.clipboard.writeText(document.querySelector('link[rel="canonical"]')?.href || location.href);button.textContent = this.dataset.copied; }
        catch { button.textContent = this.dataset.copyError; }
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorted-home-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sorted-catalogue')) {
  customElements.define('sorted-catalogue', class SortedCatalogue extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.addEventListener('submit', (event) => this.onSubmit(event), { signal: this.events.signal });
      this.addEventListener('change', (event) => {
        const form = event.target.closest('.sc-product-form');
        if (form) this.syncForm(form);
      }, { signal: this.events.signal });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cart-open]');
        if (button) this.openCart(button);
      }, { signal: this.events.signal });
      this.querySelectorAll('.sc-product-form').forEach((form) => this.syncForm(form));
    }

    disconnectedCallback() {
      this.events?.abort();
    }

    syncForm(form) {
      const field = form.querySelector('[name="id"]');
      const option = field?.selectedOptions?.[0];
      const needsQuote = option?.dataset.quote === 'true';
      const unavailable = option?.dataset.available === 'false';
      const button = form.querySelector('[type="submit"]');
      button.disabled = Boolean(this.busy || !field?.value || needsQuote || unavailable);
      const quoteLink = form.querySelector('[data-quote-link]');
      if (quoteLink) { quoteLink.hidden = !needsQuote; if (needsQuote) quoteLink.href = '/pages/freight-quote?product=' + encodeURIComponent(form.dataset.productHandle) + '&variant=' + encodeURIComponent(field.value); }
      const price = form.closest('.sc-product')?.querySelector('[data-card-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (needsQuote) this.setFeedback(form, this.dataset.freightNote, false);
      else if (!this.busy) this.setFeedback(form, '', false);
    }

    setFeedback(form, message, isError) {
      const status = form.querySelector('[data-cart-feedback]');
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('sc-cart-feedback-error', Boolean(isError));
    }

    getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    sectionIds(cart) {
      return cart?.getSectionsToRender?.().map((section) => section.id).slice(0, 5) || ['cart-icon-bubble'];
    }

    async readSections(ids) {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', ids.join(','));
      const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    }

    updateIcon(sections) {
      if (!sections?.['cart-icon-bubble']) return;
      const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const content = parsed.querySelector('.shopify-section');
      const icon = document.getElementById('cart-icon-bubble');
      if (content && icon) icon.innerHTML = content.innerHTML;
    }

    async renderCart(cart, state, trigger) {
      const ids = this.sectionIds(cart);
      let sections = state.sections;
      if (!ids.every((id) => typeof sections?.[id] === 'string' && sections[id].trim())) {
        try { sections = await this.readSections(ids); } catch { this.updateIcon(sections); return false; }
      }
      this.updateIcon(sections);
      if (!cart || typeof cart.renderContents !== 'function') return false;
      if (!ids.every((id) => typeof sections?.[id] === 'string' && sections[id].trim())) return false;
      try {
        cart.setActiveElement?.(trigger);
        cart.classList.remove('is-empty');
        cart.renderContents({ ...state, sections });
        return true;
      } catch {
        return false;
      }
    }

    async onSubmit(event) {
      const form = event.target.closest('.sc-product-form');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      if (this.busy) return;
      const field = form.querySelector('[name="id"]');
      const option = field?.selectedOptions?.[0];
      if (!field?.value || option?.dataset.available === 'false' || option?.dataset.quote === 'true') {
        this.syncForm(form);
        if (!field?.value) form.reportValidity();
        return;
      }
      const button = form.querySelector('[type="submit"]');
      const label = button.querySelector('[data-button-label]');
      const originalLabel = label.textContent;
      const cart = this.getCart();
      const formData = new FormData(form);
      formData.set('sections', this.sectionIds(cart).join(','));
      formData.set('sections_url', window.location.pathname + window.location.search);
      this.busy = true;
      this.querySelectorAll('.sc-product-form [type="submit"]').forEach((element) => { element.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      label.textContent = this.dataset.adding;
      const viewButton = form.querySelector('[data-cart-open]');
      viewButton.hidden = true;
      this.setFeedback(form, '', false);
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const state = await response.json();
        if (!response.ok || state.status) {
          const message = typeof state.description === 'string' ? state.description : this.dataset.error;
          this.setFeedback(form, message, true);
          viewButton.hidden = false;
          return;
        }
        if (!state.id && !state.items?.length) throw new Error('Unconfirmed cart response');
        confirmed = true;
        this.lastAdded = state;
        const rendered = await this.renderCart(cart, state, button);
        this.setFeedback(form, rendered ? this.dataset.added : this.dataset.addedFallback, false);
        viewButton.hidden = false;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sorted-catalogue', productVariantId: formData.get('id'), cartData: state })).catch(() => {});
        }
      } catch {
        this.setFeedback(form, confirmed ? this.dataset.addedFallback : this.dataset.uncertain, !confirmed);
        viewButton.hidden = false;
      } finally {
        this.busy = false;
        form.removeAttribute('aria-busy');
        label.textContent = originalLabel;
        this.querySelectorAll('.sc-product-form').forEach((item) => {
          const input = item.querySelector('[name="id"]');
          const selected = input?.selectedOptions?.[0];
          item.querySelector('[type="submit"]').disabled = !input?.value || selected?.dataset.quote === 'true' || selected?.dataset.available === 'false';
        });
      }
    }

    async openCart(button) {
      if (this.busy || button.disabled) return;
      const form = button.closest('.sc-product-form');
      button.disabled = true;
      try {
        const cart = this.getCart();
        const rendered = await this.renderCart(cart, { ...this.lastAdded, sections: null }, button);
        if (!rendered) this.setFeedback(form, this.dataset.refreshError, true);
      } catch {
        this.setFeedback(form, this.dataset.refreshError, true);
      } finally {
        button.disabled = false;
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorted-product-cro-generic"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sorted-generic-mobile-atc]').forEach((bar) => {
    const primaryButton = document.querySelector('.product-form__submit');
    const stickyButton = bar.querySelector('[data-sorted-generic-mobile-atc-button]');
    if (!primaryButton || !stickyButton) return;
    const syncState = () => {
      stickyButton.disabled = primaryButton.disabled;
      stickyButton.setAttribute('aria-disabled', String(primaryButton.disabled));
    };
    syncState();
    new MutationObserver(syncState).observe(primaryButton, { attributes: true, attributeFilter: ['disabled'] });
    stickyButton.addEventListener('click', () => {
      if (primaryButton.disabled) {
        primaryButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primaryButton.click();
    });
    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.2 }).observe(primaryButton);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorted-product-cro"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sorted-mobile-atc]').forEach((bar) => {
    const primaryButton = document.querySelector('.product-form__submit');
    const stickyButton = bar.querySelector('[data-sorted-mobile-atc-button]');
    if (!primaryButton || !stickyButton) return;
    const syncState = () => {
      stickyButton.disabled = primaryButton.disabled;
      stickyButton.setAttribute('aria-disabled', String(primaryButton.disabled));
    };
    syncState();
    new MutationObserver(syncState).observe(primaryButton, { attributes: true, attributeFilter: ['disabled'] });
    stickyButton.addEventListener('click', () => {
      if (primaryButton.disabled) {
        primaryButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primaryButton.click();
    });
    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.2 }).observe(primaryButton);
  });

  } catch(e) { console.error(e); }
})();
})();
